module.exports = __webpack_public_path__ + "static/media/full.2e343fc4.png";